import { useMemo } from "react"

import { Strong } from "@/styles/Markdown.ts"

export const EmailMention = (props: {
  url: string
}) => {
  const email = useMemo(() => {
    const mailtoPrefix = "mailto:"

    return props.url.startsWith(mailtoPrefix)
      ? props.url.substring(mailtoPrefix.length)
      : props.url
  }, [props.url])

  return (
    <strong className={Strong}>
      {email}
    </strong>
  )
}
